export const WroStatusesMessages = {
  'en-US': {
    wroStatuses: {
      Unknown: 'Unknown',
      AwaitingArrival: 'Awaiting Arrival',
      Processing: 'Processing',
      Received: 'Receiving Complete',
      Cancelled: 'Cancelled',
      Draft: 'Draft (Legacy)',
      Arrived: 'Arrived',
      PartiallyArrived: 'Partially Arrived',
      PartiallyArrivedAtHub: 'Partially Arrived At Hub',
      ArrivedAtHub: 'Arrived At Hub',
      ProcessingAtHub: 'Processing At Hub',
      InternalTransfer: 'Internal Transfer'
    }
  }
}

export const WroBoxStatusesMessages = {
  'en-US': {
    wroBoxStatuses: {
      Unknown: 'Unknown',
      Awaiting: 'Awaiting',
      Arrived: 'Arrived',
      Completed: 'Completed',
      Counting: 'Counting',
      Stowing: 'Stowing',
      Cancelled: 'Cancelled',
      InternalTransfer: 'Internal Transfer'
    }
  }
}

export const WroSendOptionsMessages = {
  'en-US': {
    wroSendOptions: {
      Unknown: 'Unknown',
      SendOnOwn: 'Send On Own',
      GetPrepaidShippingLabels: 'Get Prepaid Shipping Labels'
    }
  }
}

export const WroPackageTypesMessages = {
  'en-US': {
    wroPackageTypes: {
      Unknown: 'Unknown',
      Box: 'Box',
      Pallet: 'Pallet',
      FloorLoadedContainer: 'Floor loaded container'
    }
  }
}

export const WroBoxConfigurationMessages = {
  'en-US': {
    wroBoxConfigurations: {
      Unknown: 'Unknown',
      OneSkuPerBox: 'Single SKU per Box',
      MultipleSkuPerBox: 'Multiple SKU\'s per Box'
    }
  }
}

export const WroColumnNamesMessages = {
  'en-US': {
    wroColumnNames: {
      Id: 'WRO ID',
      PurchaseOrderNumber: 'PO #',
      CreationDate: 'Creation Date',
      FulfillmentCenter: 'Fulfillment Center',
      WroSummary: 'WRO Summary',
      ReturnId: 'Return ID',
      LastUpdatedDate: 'Last Updated',
      Status: 'Status'
    }
  }
}

export const WroFilterMessages = {
  'en-US': {
    wroFilters: {
      HideReturns: 'Hide Returns',
      AwaitingArrival: 'Awaiting Arrival',
      Processing: 'Processing',
      Received: 'Received',
      Cancelled: 'Cancelled',
      Draft: 'Draft',
      Arrived: 'Arrived',
      PartiallyArrived: 'Partially Arrived',
      NoCancelled: 'No Cancelled',
      OnlyReturns: 'Only Returns',
      WroId: 'WRO ID',
      FulfillmentCenter: 'Fulfillment Center',
      Product: 'Product',
      Hub: ''
    }
  }
}

export const WroBoxSlaMessages = {
  'en-US': {
    wroBoxSla: {
      Unknown: '',
      Pending: 'Pending Receiving:',
      OnTime: 'On time:',
      Late: 'Late:',
      Delayed: 'Late',
      PendingMessage: 'The box is expected to be received by {expextedSLADate}, as per our',
      OnTimeMessage: 'This box was received within {numberOfDaysInReceiving} business day(s) of its arrival.',
      LateMessage: 'This box was received in {numberOfDaysInReceiving} business day(s) of its arrival.',
      DelayedMessage: 'This box was expected to be received by {expextedSLADate} and has not met the SLA.'
    }
  }
}

const slaHelpArticleLink = '<a target="_blank" href="https://support.shipbob.com/en/articles/3983367-shipbob-s-turnaround-times-policies-and-slas">here</a>'

export const WroSlaStatusMessages = {
  'en-US': {
    wroSlaStatus: {
      Unknown: '',
      Pending: 'Pending Receiving:',
      OnTime: 'On time:',
      Late: 'Late:',
      PendingWroDetailsMessage: `All the boxes in this WRO have not been completed yet. Learn more about our SLA ${slaHelpArticleLink}.`,
      OnTimeWroDetailsMessage: `All boxes in this WRO were received within the SLA. Learn more about our SLA policy ${slaHelpArticleLink}.`,
      LateWroDetailsMessage: `One or more boxes in this WRO were not received within the SLA. Learn more about our SLA ${slaHelpArticleLink}.`,
      PendingWroMessage: `All the boxes in this WRO have not been completed yet. For more details, view the WRO summary page. Learn more about our SLA ${slaHelpArticleLink}.`,
      OnTimeWroMessage: `All boxes in this WRO were received within the SLA. For more details, view the WRO summary page. Learn more about our SLA policy ${slaHelpArticleLink}.`,
      LateWroMessage: `One or more boxes in this WRO were not received within the SLA. For more details, view the WRO summary page. Learn more about our SLA ${slaHelpArticleLink}.`
    }
  }
}
